import { render, staticRenderFns } from "./voteDetailsList.vue?vue&type=template&id=d74acdfe&scoped=true&"
import script from "./voteDetailsList.vue?vue&type=script&lang=js&"
export * from "./voteDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./voteDetailsList.vue?vue&type=style&index=0&id=d74acdfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74acdfe",
  null
  
)

export default component.exports